<script lang="ts">
  import { quintOut } from 'svelte/easing';
  import { slide } from 'svelte/transition';

  import { Avatar } from '@shared/ui/avatar';
  import { Icon } from '@shared/ui/icon';
  import { convertDateToUserTimeZone } from '@shared/utils';

  import { walletLibs } from '@entities/wallet';

  import { historyTypes } from '../configs';
  import { getCurrencyName } from '../libs';
  import type { HistoryType } from '../types';

  export let history: HistoryType[] = [];
  export let currencies: any | undefined = undefined;
</script>

<ul class="flex flex-col" transition:slide="{{ duration: 300, easing: quintOut, axis: 'y' }}">
  {#each history as item}
    <li
      class="border-default-300 dark:border-dark-300 flex items-center justify-between gap-4 border-b py-5 last:border-0 last:pb-3 first-of-type:pt-0"
    >
      <div class="flex items-center gap-5">
        <div class="icon">
          {#if item.icon}
            <Icon name="{item.icon}" />
          {:else}
            <Avatar wallet="{item.fromValue?.value}" />
          {/if}
        </div>

        <div>
          <div class="text-sm">
            <span class="font-bold">{item.label}</span>
            {#if item.type === historyTypes.transfer}
              <a class="underline" href="{item.fromValue?.explorer_url}" target="_blank">
                {walletLibs.formatWalletId(item.fromValue?.value, false)}
              </a>
            {/if}

            {#if item.type === historyTypes.mint}
              <a class="underline" href="{item.mintedToValue?.explorer_url}" target="_blank">
                {walletLibs.formatWalletId(item.mintedToValue?.value, false)}
              </a>
            {/if}

            <div class="inline-block">
              <!-- move 'to' text to this block to prettify break line wrap -->
              {#if item.type === historyTypes.transfer}to
              {/if}
              <a class="underline" href="{item.toValue?.explorer_url}" target="_blank">
                {walletLibs.formatWalletId(item.toValue?.value, false)}
              </a>

              {#if item.type === historyTypes.auctionCreated || item.type === historyTypes.auctionBidPlaced}
                <a class="underline" href="{item.fromValue?.explorer_url}" target="_blank">
                  {walletLibs.formatWalletId(item.fromValue?.value, false)}
                </a>
              {/if}

              {#if item.type === historyTypes.auctionSold}
                <a class="underline" href="{item.buyer?.explorer_url}" target="_blank">
                  {walletLibs.formatWalletId(item.buyer?.value, false)}
                </a>

                {#if item.type === historyTypes.auctionSold}
                  <span class="font-bold">won.</span>
                {/if}
              {/if}
            </div>
          </div>

          <p class="text-default-600 dark:text-dark-600 text-xs">{convertDateToUserTimeZone(+item.date)}</p>
        </div>
      </div>

      {#if item.type === historyTypes.auctionBidPlaced || item.type === historyTypes.buy || item.type === historyTypes.auctionSold}
        <div class="flex shrink-0 items-center justify-end gap-2">
          <p class="text-right text-xs font-medium uppercase md:text-sm">
            {item.price}
            {getCurrencyName(currencies, item.currency ?? '') || 'USDC'}
          </p>

          {#if item.tx}
            <a href="{item.tx.explorer_url}" target="_blank"><Icon name="open" /></a>
          {/if}
        </div>
      {/if}
    </li>
  {/each}
</ul>
